import { Empty } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import TreeBranch from '../TreeBranch/TreeBranch';

const Tree = ({ data = [] }) => {
  if (data?.length) {
    return data?.map((object) => (
      <TreeBranch allData={data} key={object.id} object={object} />
    ));
  } else {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }
};

Tree.propTypes = {
  // допускается наличие других данных
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      canBeChecked: PropTypes.bool.isRequired,
      onSelectChange: PropTypes.func, // (object, checked, allData) => ...
      checked: PropTypes.bool,
      indeterminate: PropTypes.bool,
      children: PropTypes.arrayOf(PropTypes.object), // такие же как родитель
    })
  ).isRequired,
};

export default memo(Tree);
